/****   app.js   ****/
// 导入封装好的axios实例
import request from './request'
import qs from 'qs';

// 不同环境的切换
let base = '';
if (process.env.NODE_ENV == 'development') {
    base = 'http://127.0.0.1:28101';
} else if (process.env.NODE_ENV == 'debug') {
    base = 'http://127.0.0.1:28101';
} else if (process.env.NODE_ENV == 'production') {
    // base = 'http://ip365.ppfly.work:28101/';
    // base = 'https://ip365.ppfly.work';
    base = '';
}

let contentType1 = 'application/x-www-form-urlencoded';
let contentType2 = 'application/json';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()));
    return '';
}

/**
 * 封装适合不同请求类型的方法https://apiupss.ppfly.top
 * @param method 请求类型
 * @param url 请求地址
 * @param params 请求参数
 * @param header 请求头
 * @param token 用户的身份令牌
 */
function Request(method, url, params, header, token) {
    url = `${base}` + url;

    try {
        if (!token) token = getCookie("userdata").data.token;
    } catch (e) {
        console.log(e)
    }
    // 构建请求头
    header = {
        'Content-Type': header || 'application/json',
        ...(token && {'Authorization': `Bearer ${token}`}) // 如果有token，则添加到请求头
    };

    let config = {};
    switch (method) {
        case 'get':
            config = {
                method: method,
                url: url,
                headers: header
            };
            if (params) config.params = params;
            return request(config);
        case 'delete':
            config = {
                method: method,
                url: url,
                headers: header
            };
            if (params) config.params = params;
            return request(config);
        case 'post':
            config = {
                method: method,
                url: url,
                headers: header
            };
            if (params) config.data = JSON.stringify(params);
            return request(config);
        case 'put':
            config = {
                method: method,
                url: url,
                headers: header
            };
            if (params) config.data = qs.stringify(params);
            return request(config);
    }
}

export default {
    // 调用封装好的方法，把不同的请求暴露出去
    register(params, token) {
        return Request('post', '/api/register', params, contentType2, token)
    },
    loginIn(params, token) {
        return Request('post', '/api/login', params, contentType2, token)
    },
    update_password(params, token) {
        return Request('post', '/api/change-password', params, contentType2, token)
    },
    product_list(params, token) {
        return Request('get', '/api/product/list', params, contentType2, token)
    },
    product_price(params, token) {
        return Request('post', '/api/product/price', params, contentType2, token)
    },
    buy(params, token) {
        return Request('post', '/api/order/create', params, contentType2, token)
    },
    user_balance(params, token) {
        return Request('post', '/api/user/balance', params, contentType2, token)
    },
    user_reset_key(params, token) {
        return Request('post', '/api/user/reset_key', params, contentType2, token)
    },
    order_list(params, token) {
        return Request('post', '/api/order/list', params, contentType2, token)
    },
    ip_resource_list(params, token) {
        return Request('post', '/api/order/ip_resource_list', params, contentType2, token)
    },
    pay_list(params, token) {
        return Request('post', '/api/order/pay_list', params, contentType2, token)
    },
    check_order(params, token) {
        return Request('post', '/api/order/check_order', params, contentType2, token)
    },


    white_list(params, token) {
        return Request('post', '/interface/api/white_list.act', params, contentType2, token)
    },
    white_create(params, token) {
        return Request('post', '/interface/api/white_add.act', params, contentType2, token)
    },
    delete_create(params, token) {
        return Request('post', '/interface/api/white_del.act', params, contentType2, token)
    },

    login_by_captcha(params, token) {
        return Request('post', '/user/login_by_captcha', params, contentType2, token)
    },
    send_captcha(params, token) {
        return Request('post', '/user/send_captcha', params, contentType2, token)
    },
    set_meal(params, token) {
        return Request('post', '/set_meal/get', params, contentType2, token)
    },
    auth(params, token) {
        return Request('post', '/user/auth', params, contentType2, token)
    },
    getauth(params, token) {
        return Request('post', '/user/get', params, contentType2, token)
    },
    ip_list(params, token) {
        return Request('post', '/ip_list/get', params, contentType2, token)
    },
    black_get(params, token) {
        return Request('post', '/black_list/get', params, contentType2, token)
    },
    black_update(params, token) {
        return Request('post', '/black_list/update', params, contentType2, token)
    },
    black_delete(params, token) {
        return Request('post', '/black_list/delete', params, contentType2, token)
    },
    ye_get(params, token) {
        return Request('post', '/order/ye/get', params, contentType2, token)
    },
    dt_get(params, token) {
        return Request('post', '/order/dt/get', params, contentType2, token)
    },
    jt_get(params, token) {
        return Request('post', '/order/jt/get', params, contentType2, token)
    },
    dx_get(params, token) {
        return Request('post', '/order/dx/get', params, contentType2, token)
    },
    qy_auth(params, token) {
        return Request('post', '/user/qy_auth/get', params, contentType2, token)
    },
    jtzz_get(params, token) {
        return Request('post', '/user/jtzz/get', params, contentType2, token)
    },
    sjzx_get(params, token) {
        return Request('post', '/user/sjzx/get', params, contentType2, token)
    },
    ye_get_user(params, token) {
        return Request('post', '/user/ye/get', params, contentType2, token)
    },
    ll_get_user(params, token) {
        return Request('post', '/user/ll/get', params, contentType2, token)
    },
    up_child_create(params, token) {
        return Request('post', '/up_child/create', params, contentType2, token)
    },
    up_child_get(params, token) {
        return Request('post', '/up_child/get', params, contentType2, token)
    },
    up_child_update(params, token) {
        return Request('post', '/up_child/update', params, contentType2, token)
    },
    up_child_jy(params, token) {
        return Request('post', '/up_child/jy', params, contentType2, token)
    },
    //中间页
    FaceID(params, token) {
        return Request('post', '/FaceID', params, contentType2, token)
    },

    order_create(params, token) {
        return Request('post', '/order/ye/create', params, contentType2, token)
    },
    // /user/ye/get
    // /user/ye/get   /up_child/jy
}
